"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    inputLabel: {
      position: 'static',
      marginBottom: 10,
      color: theme.palette.NEUTRAL300,
      transform: 'translate(0, 1.5px) scale(0.80)',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: theme.typography.fontWeightMedium,
      '&.Mui-focused': {
        color: theme.palette.BLUE400
      }
    },
    secondaryLabel: {
      color: theme.palette.NEUTRAL300,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: theme.typography.fontWeightRegular
    },
    rangeContainer: {
      padding: theme.spacing(0, 1.25)
    }
  });
});
var _default = useStyles;
exports.default = _default;